import type { Locale } from '@/i18n/config'

/**
 * Inline editing in the preview: every database text value rendered on a page
 * carries data-mdlfy-cms="<table>:<row id>:<column>" on the element that holds
 * exactly that value. Use the real column name, including the __sq suffix when
 * the Albanian value is shown.
 */
export const cmsKey = (table: string, id: string, column: string): string => `${table}:${id}:${column}`

/** Column that holds a translatable value for the locale: `title` for English, `title__sq` for Albanian. */
export const localeColumn = (column: string, locale: Locale): string => locale === 'sq' ? `${column}__sq` : column

/**
 * Pick the localized value of a translatable column and the column it came from,
 * falling back to the English base column when the translation is empty.
 */
export const localized = (row: Record<string, unknown>, column: string, locale: Locale): { value: string, column: string } => {
    if (locale === 'sq') {
        const translated = row[`${column}__sq`]
        if (typeof translated === 'string' && translated.trim() !== '') return { value: translated, column: `${column}__sq` }
    }

    const base = row[column]
    return { value: typeof base === 'string' ? base : base === null || base === undefined ? '' : String(base), column }
}
